<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '维修信息'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5%"
    class="ds-detail"
    :close-on-click-modal="false"
  >
    <el-tabs
      type="border-card"
      ref="tabs"
      v-model="activeTab"
      style="margin-top: -30px"
    >
      <el-tab-pane label="维修登记" name="tabRegister">
        <el-form
          :model="item"
          ref="itemform"
          label-width="150px"
          :rules="rules"
        >
          <el-form-item label="维修类型" prop="Type">
            <el-radio-group v-model="item.Type" :disabled="editting">
              <el-radio :label="0">产品</el-radio>
              <el-radio :label="1">配件</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="item.Type === 0"
            label="产品型号名称"
            prop="modDciProductModelID"
          >
            <!-- <select2
              style="width: 100%"
              labelName="NameNumber"
              v-model="modDciProductModelID"
              url="dci/model/product/list?order=name"
              :clearable="false"
              placeholder="请选择产品型号名称"
              no-data-text="没有产品型号名称"
              :disabled="editting"
              :currentList="curDciProductModelID"
              :queryOne="false"
            ></select2> -->
            <el-select
              v-model="modDciProductModelName"
              :clearable="false"
              placeholder="选择产品型号"
              style="width: 100%"
              :disabled="editting"
            >
              <el-option
                v-for="ele in modelList"
                :key="ele"
                :label="ele"
                :value="ele"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="item.Type === 0"
            label="产品SN"
            prop="DciProductID"
          >
            <select2
              style="width: 100%"
              labelName="SNRemark"
              v-model="item.DciProductID"
              :url="productUrl"
              :urlParams="urlParams"
              :clearable="false"
              placeholder="请选择产品SN"
              :disabled="!modDciProductModelName || editting"
              no-data-text="无产品"
              :currentList="curDciProductID"
              q="SN|Remark:like"
              :qinwhere="true"
              :queryOne="false"
            ></select2>
          </el-form-item>
          <el-form-item
            v-if="item.Type === 1"
            label="配件型号名称"
            prop="DciAccessoryModelID"
          >
            <select2
              style="width: 100%"
              labelName="NameNumber"
              v-model="modDciAccessoryModelID"
              url="dci/model/accessory/list?order=name"
              :clearable="false"
              placeholder="请选择配件型号名称"
              no-data-text="没有配件型号名称"
              :disabled="editting"
              :currentList="curDciAccessoryModelID"
              :queryOne="false"
            ></select2>
          </el-form-item>
          <el-form-item
            v-if="item.Type === 1"
            label="配件SN"
            prop="DciAccessoryID"
          >
            <select2
              style="width: 100%"
              labelName="SN"
              v-model="item.DciAccessoryID"
              :url="accessoryUrl"
              :urlParams="{
                where: {},
              }"
              :clearable="false"
              placeholder="请选择配件SN"
              :disabled="!modDciAccessoryModelID || editting"
              no-data-text="无配件"
              :currentList="curDciAccessoryID"
              q="SN:like"
              :qinwhere="true"
              :queryOne="false"
            ></select2>
          </el-form-item>
          <el-form-item label="送修来源" prop="SendSource">
            <el-input
              v-model.trim="item.SendSource"
              placeholder="请输入送修来源"
            ></el-input>
          </el-form-item>
          <el-form-item label="登记人" prop="SendPeopleID">
            <select2
              style="width: 100%"
              labelName="Name"
              v-model="item.SendPeopleID"
              url="user"
              :clearable="false"
              placeholder="请选择登记人"
              no-data-text="没有用户"
              :emptyValue="0"
              :currentList="curSendPeopleID"
              disabled
            ></select2>
          </el-form-item>
          <el-form-item label="送修日期" prop="SendAt">
            <el-date-picker
              v-model="item.SendAt"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="期望初检完成日期" prop="ExpectedInspectAt">
            <el-date-picker
              v-model="item.ExpectedInspectAt"
              style="width: 100%"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="期望维修完成日期" prop="ExpectedDealAt">
            <el-date-picker
              v-model="item.ExpectedDealAt"
              style="width: 100%"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="临期提醒天数" prop="TenseDays">
            <el-input-number
              v-model="item.TenseDays"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="故障说明" prop="MalfunctionDesc">
            <el-input
              v-model.trim="item.MalfunctionDesc"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入说明"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="产品信息" v-if="item.Type === 0" name="tabProInfo">
        <div class="border-style">产品信息</div>
        <el-form :model="proInfoItem" v-if="proInfoItem.ID" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="
              width: 100%;
              border-collapse: collapse;
              font-size: 13px;
              margin-bottom: 15px;
            "
          >
            <tr>
              <th width="15%">产品型号名称</th>
              <td width="35%">
                <div v-if="proInfoItem.DciProductModel">
                  {{ proInfoItem.DciProductModel.Name }}
                </div>
              </td>
              <th width="15%">产品型号</th>
              <td width="35%">
                <div v-if="proInfoItem.DciProductModel">
                  {{ proInfoItem.DciProductModel.Number }}
                </div>
              </td>
            </tr>
            <tr>
              <th>产品SN</th>
              <td>
                <div v-if="proInfoItem.SN">
                  {{ proInfoItem.SN }}
                </div>
                <div v-if="proInfoItem.Remark">
                  {{ proInfoItem.Remark }}
                </div>
              </td>
              <th>文件系统版本</th>
              <td>
                <div v-if="proInfoItem.DciPvProductVersion">
                  {{ proInfoItem.DciPvProductVersion.PvName }}
                </div>
              </td>
            </tr>
            <tr>
              <th>质保开始日期</th>
              <td>
                {{ $sys.dateFormat(proInfoItem.QualityStartAt, "Y-m-d") }}
              </td>
              <th>质保开始日期</th>
              <td>{{ $sys.dateFormat(proInfoItem.QualityEndAt, "Y-m-d") }}</td>
            </tr>
            <tr>
              <th>客户</th>
              <td>{{ proInfoItem.ClientName }}</td>
              <th>出库日期</th>
              <td>{{ $sys.dateFormat(proInfoItem.StockoutAt, "Y-m-d") }}</td>
            </tr>
            <tr>
              <th>出库单号</th>
              <td>{{ proInfoItem.CheckoutNo }}</td>
              <th>出库经办人</th>
              <td>{{ proInfoItem.Operator }}</td>
            </tr>
            <tr>
              <th>合同编号</th>
              <!-- <td>{{ proInfoItem.ContractNo }}</td> -->
              <td>
                <el-tag
                  v-for="contractNo in proInfoItem.ContractNos"
                  :key="contractNo"
                  style="margin-right: 5px; color: #00b3ca"
                  >{{ contractNo }}</el-tag
                >
              </td>
              <th>领用人</th>
              <td>{{ proInfoItem.Recipient }}</td>
            </tr>
            <tr>
              <th>出库备注</th>
              <td colspan="3">{{ proInfoItem.StockoutReason }}</td>
            </tr>
            <tr>
              <th>点位名称</th>
              <td>
                <div v-if="proInfoItem.DciStation">
                  {{ proInfoItem.DciStation.Name }}
                </div>
              </td>
              <th>MN</th>
              <td>
                <div v-if="proInfoItem.DciStation">
                  {{ proInfoItem.DciStation.MN }}
                </div>
              </td>
            </tr>
          </table>
        </el-form>

        <div class="border-style">运维信息</div>
        <el-form :model="contractItem" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="width: 100%; border-collapse: collapse; font-size: 13px"
          >
            <tr height="40">
              <th width="15%">运维合同编号</th>
              <td width="35%" v-if="contractItem">
                {{ contractItem.sn }}
              </td>
              <td v-else></td>
              <th width="15%">合同客户企业</th>
              <td width="35%" v-if="contractItem && contractItem.Partner">
                {{ contractItem.Partner.name }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>运维开始日期</th>
              <td v-if="contractItem && contractItem.begin_at">
                {{ $sys.dateFormat(contractItem.begin_at, "Y-m-d") }}
              </td>
              <td v-else></td>
              <th>运维结束日期</th>
              <td v-if="contractItem && contractItem.end_at">
                {{ $sys.dateFormat(contractItem.end_at, "Y-m-d") }}
              </td>
              <td v-else></td>
            </tr>
            <tr height="40">
              <th>负责小组</th>
              <td v-if="contractItem">
                {{ contractItem.team_name }}
              </td>
              <td v-else></td>
              <th>负责人</th>
              <td v-if="contractItem">
                {{ contractItem.staff_name }}
              </td>
              <td v-else></td>
            </tr>
          </table>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="配件信息" v-if="item.Type === 1" name="tabAccInfo">
        <el-form :model="accInfoItem" v-if="accInfoItem.ID" label-width="150px">
          <table
            border="1"
            bordercolor="#dedede"
            style="width: 100%; border-collapse: collapse; font-size: 13px"
          >
            <tr>
              <th width="15%">配件型号名称</th>
              <td width="35%">
                <div v-if="accInfoItem.DciAccessoryModel">
                  {{ accInfoItem.DciAccessoryModel.Name }}
                </div>
              </td>
              <th width="15%">配件型号</th>
              <td width="35%">
                <div v-if="accInfoItem.DciAccessoryModel">
                  {{ accInfoItem.DciAccessoryModel.Number }}
                </div>
              </td>
            </tr>
            <tr>
              <th>配件SN</th>
              <td>{{ accInfoItem.SN }}</td>
              <th>关联产品SN</th>
              <td>
                <div v-if="accInfoItem.DciProduct">
                  {{ accInfoItem.DciProduct.SN }}
                </div>
                <div v-else>——</div>
              </td>
            </tr>
            <tr>
              <th>客户</th>
              <td>{{ accInfoItem.ClientName }}</td>
              <th>质保开始日期</th>
              <td>
                {{ $sys.dateFormat(accInfoItem.QualityStartAt, "Y-m-d") }}
              </td>
            </tr>
            <tr>
              <th>出库日期</th>
              <td>{{ $sys.dateFormat(accInfoItem.StockoutAt, "Y-m-d") }}</td>
              <th>质保结束日期</th>
              <td>{{ $sys.dateFormat(accInfoItem.QualityEndAt, "Y-m-d") }}</td>
            </tr>
            <tr>
              <th>出库单号</th>
              <td>{{ accInfoItem.CheckoutNo }}</td>
              <th>出库经办人</th>
              <td>{{ accInfoItem.Operator }}</td>
            </tr>
            <tr>
              <th>领用人</th>
              <td>{{ accInfoItem.Recipient }}</td>
              <th>出库备注</th>
              <td>{{ accInfoItem.StockoutReason }}</td>
            </tr>
          </table>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button
        type="primary"
        @click="onSubmit"
        v-if="visSubmitting"
        :disabled="submitting"
      >
        <i class="far fa-save"></i> 确 定
      </el-button>
      <el-button
        type="primary"
        @click="onSubmitRegister"
        v-if="visSubmitRegisting"
        :disabled="submitRegisting"
      >
        <i class="far fa-save"></i> 提交维修登记
      </el-button>
      <el-button type="primary" @click="onFinish" v-if="visFinishing">
        <i class="far fa-save"></i> 直接办结
      </el-button>
    </div>

    <finish-form
      v-model="item"
      :visible.sync="finishVisible"
      @form:saved="onFinishClose"
    />
  </el-dialog>
</template>

<script>
import finishForm from "./finishForm.vue";
export default {
  components: { finishForm },
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      activeTab: "tabRegister",
      proInfoItem: {},
      accInfoItem: {},
      // modDciProductModelID: "",
      modDciProductModelName: "",
      modDciAccessoryModelID: "",
      rules: {
        // DciProductModelID: [
        //   { required: true, message: "产品型号不能为空", trigger: "blur" },
        // ],
        DciProductID: [
          { required: true, message: "产品SN不能为空", trigger: "blur" },
        ],
        // DciAccessoryModelID: [
        //   { required: true, message: "配件型号不能为空", trigger: "blur" },
        // ],
        DciAccessoryID: [
          { required: true, message: "配件SN不能为空", trigger: "blur" },
        ],
        SendSource: [
          { required: true, message: "送修来源不能为空", trigger: "blur" },
        ],
        SendPeopleID: [
          { required: true, message: "登记人不能为空", trigger: "blur" },
        ],
        SendAt: [
          { required: true, message: "送修时间不能为空", trigger: "blur" },
        ],
        ExpectedInspectAt: [
          {
            required: true,
            message: "期望初检完成日期不能为空",
            trigger: "blur",
          },
        ],
        ExpectedDealAt: [
          {
            required: true,
            message: "期望维修完成日期不能为空",
            trigger: "blur",
          },
        ],
        MalfunctionDesc: [
          { required: true, message: "故障说明不能为空", trigger: "blur" },
        ],
        TenseDays: [
          { required: true, message: "提醒天数不能为空", trigger: "blur" },
        ],
      },
      editting: false,
      submitting: false,
      submitRegisting: false,
      finishVisible: false,
      visSubmitting: false, //是否显示确认按钮
      visSubmitRegisting: false, //是否显示提交维修登记按钮
      visFinishing: false, //是否显示直接办结按钮
      productUrl: "dci/product/stock-list/list?order=-sn",
      urlParams: { where: {} },
      accessoryUrl: "",
      // curDciProductModelID: [],
      curDciProductID: [],
      curDciAccessoryModelID: [],
      curDciAccessoryID: [],
      curSendPeopleID: [],
      modelList: [], //产品型号

      //运维合同信息
      contractItem: {
        id: "",
        sn: "", //合同编号
        begin_at: "",
        end_at: "",
        team_name: "", //负责小组
        staff_name: "", //负责人
        partner_id: "",
        Partner: {
          id: "",
          name: "", //合同客户企业
        },
      },
    };
  },
  watch: {
    // modDciProductModelID: {
    //   handler() {
    //     this.productUrl = `dci/product/stock-list/list?where[DciProductModelID]=${this.modDciProductModelID}&statusIn=2,4,8&order=-sn`;
    //   },
    // },
    modDciProductModelName: {
      handler() {
        this.productUrl = `dci/product/stock-list/list?order=-sn`;
        this.urlParams = {
          where: {},
          dciProductModelName: this.modDciProductModelName,
          statusIn: "2, 4, 8",
        };
      },
    },
    modDciAccessoryModelID: {
      handler() {
        this.accessoryUrl = `dci/accessory/stock-list/list?where[DciAccessoryModelID]=${this.modDciAccessoryModelID}&statusIn=2,4,8&order=-sn`;
      },
    },
    "item.DciProductID": {
      handler() {
        if (this.item.DciProductID) {
          this.$axios
            .get(`dci/product/${this.item.DciProductID}`)
            .then((response) => {
              this.proInfoItem = response.data;
              this.getYWInfo(this.proInfoItem.DciStation);
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      },
    },
    "item.DciAccessoryID": {
      handler() {
        if (this.item.DciAccessoryID) {
          this.$axios
            .get(`dci/accessory/${this.item.DciAccessoryID}`)
            .then((response) => {
              this.accInfoItem = response.data;
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      },
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.getModelList();
      this.initData();
      this.activeTab = "tabRegister";
      setTimeout(() => {
        //绑定配件型号和配件SN偶尔会出问题，用延时可避免
        this.bindData();
      }, 500);
    },
    initData() {
      this.proInfoItem = {};
      this.accInfoItem = {};

      this.editting = false;
      this.submitting = false;
      //新增维修记录，显示“提交维修登记”、“直接办结”按钮，不显示“确定”按钮
      this.visSubmitting = false;
      this.visSubmitRegisting = true;
      this.visFinishing = true;

      // this.curDciProductModelID = [];
      this.curDciProductID = [];
      this.curDciAccessoryModelID = [];
      this.curDciAccessoryID = [];
      // this.modDciProductModelID = "";
      this.modDciProductModelName = "";
      this.modDciAccessoryModelID = "";
      this.curSendPeopleID = [];

      if (this.item.ID) {
        //编辑状态
        this.editting = true;

        if (this.item.DciProduct.DciProductModel) {
          this.modDciProductModelName =
            this.item.DciProduct.DciProductModel.Name;
        }

        if (this.item.SendPeopleID === this.$store.state.Auth.user.ID) {
          //本人才能修改

          //维修状态是“登记中”（退回的情况），显示“提交维修登记”、“直接办结”按钮，不显示“确定”按钮
          if (this.item.DealStatus === 0) {
            this.visSubmitting = false;
            this.visSubmitRegisting = true;
            this.visFinishing = true;
          } else {
            //维修状态不是“登记中”，不显示“提交维修登记”、“直接办结”按钮，显示“确定”按钮
            this.visSubmitting = true;
            this.visSubmitRegisting = false;
            this.visFinishing = false;
          }
        } else {
          //不是本人，都不能操作
          this.visSubmitting = false;
          this.visSubmitRegisting = false;
          this.visFinishing = false;
        }
      }
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
          // this.modelList.push({
          //   ID: 0,
          //   NameNumber: "其它类型",
          // });
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    bindData() {
      if (this.item.ID) {
        //编辑状态
        if (this.item.DciProduct !== null) {
          // if (this.item.DciProduct.DciProductModel) {
          //   // this.modDciProductModelID = this.item.DciProduct.DciProductModelID;
          //   // this.curDciProductModelID = [
          //   //   {
          //   //     ID: this.item.DciProduct.DciProductModelID,
          //   //     NameNumber: this.item.DciProduct.DciProductModel.NameNumber,
          //   //   },
          //   // ];
          //   this.modDciProductModelName =
          //     this.item.DciProduct.DciProductModel.Name;
          // }

          this.curDciProductID = [
            {
              ID: this.item.DciProductID,
              SNRemark: this.item.DciProduct.SNRemark,
            },
          ];
        }

        if (this.item.DciAccessory !== null) {
          if (this.item.DciAccessory.DciAccessoryModel) {
            this.modDciAccessoryModelID =
              this.item.DciAccessory.DciAccessoryModelID;
            this.curDciAccessoryModelID = [
              {
                ID: this.item.DciAccessory.DciAccessoryModelID,
                NameNumber: this.item.DciAccessory.DciAccessoryModel.NameNumber,
              },
            ];
          }
          this.curDciAccessoryID = [
            { ID: this.item.DciAccessoryID, SN: this.item.DciAccessory.SN },
          ];
        }
        if (this.item.SendPeople) {
          this.curSendPeopleID = [
            { ID: this.item.SendPeopleID, Name: this.item.SendPeople.Name },
          ];
        }
      } else {
        if (this.$store.state.Auth.user) {
          this.curSendPeopleID = [
            {
              ID: this.$store.state.Auth.user.ID,
              Name: this.$store.state.Auth.user.Name,
            },
          ];
        }
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      // this.curDciProductModelID = [];
      this.curDciProductID = [];
      this.curDciAccessoryModelID = [];
      this.curDciAccessoryID = [];
      this.curSendPeopleID = [];
    },
    //修改信息
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const itemData = {
          ...this.item,
        };
        // 保存的操作
        this.$axios
          .request({
            url: `dci/maintain/register/${itemData.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("修改成功");
            this.submitting = false;
            // this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            // this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    //提交维修登记
    onSubmitRegister() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitRegisting = true;
        const itemData = {
          ...this.item,
        };
        // 保存的操作
        this.$axios
          .request({
            url: "dci/maintain/register",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("提交成功");
            this.submitRegisting = false;
            // this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitRegisting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    //直接办结
    onFinish() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.item.ID) {
          this.item.SendingAt = new Date();
        }
        this.finishVisible = true;
      });
    },
    onFinishClose() {
      this.$emit("form:saved", true);
      this.$emit("update:visible", false);
    },
    getYWInfo(station) {
      this.contractItem = {};
      if (station && station.MN != "") {
        this.$axios
          .get("dci/station/getContractInfo", {
            params: { mn: station.MN },
          })
          .then((response) => {
            this.contractItem = response.data;
          })
          .catch(({ response }) => {
            // this.$sys.alarmResponse(response);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ds-detail {
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
    font-size: 11px;
    table-layout: FIXED;
    word-break: break-all;
  }
  table th {
    text-align: center;
    // padding-left: 5px;
    color: #646566;
    background-color: #ecf5ff;
    font-size: 11px;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 13px;
    font-weight: bolder;
  }
}
</style>
